import { CurrencyBalance } from "@/model/data/workload/CurrencyBalance";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetTransactionTotalsResData extends ServiceResponseData {
    balances: CurrencyBalance[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Balance) {
            Object.keys(obj.Balance).forEach((cur) => {
                if (!this.balances.find((c) => c.currency == cur)) {
                    var newCurBalance = new CurrencyBalance();
                    newCurBalance.currency = cur;
                    this.balances.push(newCurBalance);
                }

                this.balances.find((c) => c.currency == cur).balance = Math.round((obj.Balance[cur] + Number.EPSILON) * 100) / 100;
            });
        }

        if (obj.CashIn) {
            Object.keys(obj.CashIn).forEach((cur) => {
                if (!this.balances.find((c) => c.currency == cur)) {
                    var newCurBalance = new CurrencyBalance();
                    newCurBalance.currency = cur;
                    this.balances.push(newCurBalance);
                }

                this.balances.find((c) => c.currency == cur).cashIn = Math.round((obj.CashIn[cur] + Number.EPSILON) * 100) / 100;
            });
        }

        if (obj.CashOut) {
            Object.keys(obj.CashOut).forEach((cur) => {
                if (!this.balances.find((c) => c.currency == cur)) {
                    var newCurBalance = new CurrencyBalance();
                    newCurBalance.currency = cur;
                    this.balances.push(newCurBalance);
                }

                this.balances.find((c) => c.currency == cur).cashOut = Math.round((obj.CashOut[cur] + Number.EPSILON) * 100) / 100;
            });
        }
    }
}
